import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter, Route, RouterProvider, Routes } from "react-router-dom";
import axios from "axios";
import router from "./router";
import Loader from "./Component/loader/Loader";
import AccountDisabledModal from "./Component/AccountDisabledModal";

function App() {
  const [showAccountDisabledModal, setShowAccountDisabledModal] =
    useState(false);

  useEffect(() => {
    const handleAccountDisabled = () => setShowAccountDisabledModal(true);
    window.addEventListener("accountDisabled", handleAccountDisabled);
    return () =>
      window.removeEventListener("accountDisabled", handleAccountDisabled);
  }, []);
  // const Login = lazy(() => import("./Component/Auth/Login"));
  // const HomePage = lazy(() => import("./Component/pages/homePage/HomePage"));
  // const Register = lazy(() => import("./Component/Auth/Register"));
  // const ForgetPassword = lazy(() => import("./Component/Auth/ForgetPassword"));
  // const OtpVerify = lazy(() => import("./Component/Auth/OtpVerify"));
  // const Services = lazy(() =>
  //   import("./Component/pages/otherPages/services/Services")
  // );
  // const Dashboard = lazy(() =>
  //   import("./Component/pages/otherPages/dashboard/Dashboard")
  // );

  // axios.defaults.baseURL = "http://localhost:9734/api/v1";

  // return (
  //   <>

  //   </>
  // );

  return (
    <>
      <Suspense fallback={<Loader />}>
        <RouterProvider router={router} />
      </Suspense>
      <AccountDisabledModal
        open={showAccountDisabledModal}
        onOkay={() => {
          setShowAccountDisabledModal(false);
          window.location.href = "/auth/login";
        }}
      />
    </>
  );
}

export default App;
